import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {msg} from '@lit/localize';
import store from '../store';

import {getValueOfFeature, pimText} from '../util/values';
import {conditional} from '../util/conditional';
import {selectVariantCodeTypes} from '../selectors';
import { downloadCSV } from '../slices/configurationSlice';
import {
	selectSolarActivityLevel, selectSolarAzimuth,
	selectSolarAzimuthAngle,
	selectSolarDimmProfile,
	selectSolarLocation,
	selectSolarShadowLevel
} from '../solar/solarSelectors';

@customElement('download-csv')
export class DownloadCSV extends connect(store)(LitElement) {

	static styles = [
		css`
			.downloadBtns {
				display: flex;
				gap: var(--small-padding);
			}
			button {
				display: flex;
				background-color: transparent;
				box-shadow: none;
				border: 1px solid #fff;
				color: #fff;
				font-family: var(--font-family-light);
				font-size: 12px;
				font-style: normal;
				font-weight: 400;
				line-height: 19px;
				padding: 5px 10px;
				cursor: pointer;
				white-space: nowrap;
			}
			section {
				padding: var(--padding);
				border-bottom: 1px solid var(--color-black);
			}
		`
	];

	separator = '|';

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.lang = state.status.lang;
		this.conditionalVariantValues = state.productData.conditionalVariantValues;
		this.originalConditionalVariantValues = state.productData.originalConditionalVariantValues;
		this.price = state.price.data;
		this.decisions = state.decisions.data;
		this.shortNumberProductModel = state.shortNumber.data.ProductModel ?? '';

		this.userProfile = state.userProfile.data;
		this.info = state.configuration.data.projects[0].project.info;
		this.status = state.status;
		this.lightProfile = state.lightProfile.data;
		this.isSolar = state.status.family === 'Aeto';

	}

	async downloadCSV() {
		const csvContent = [];
		csvContent.push(['ID', 'VALUE']);
		csvContent.push(...this.decisions.decisions.map(feature => {
					const featureId = feature.variableId;
					const valueId = getValueOfFeature(feature.variableId, this.decisions);
					// const featureLabel = pimText(this.lang, featureId, 'F', this.decisions, this.state.productData.translations);
					// const valueLabel = pimText(this.lang, featureId, 'FV', this.decisions, this.state.productData.translations, valueId);
					return [featureId, valueId];
				}
			)
		);

		csvContent.push(['', '']);

		const conditionals = [];
		this.originalConditionalVariantValues.forEach(cvv => {
			const cond = conditional(this.decisions, this.conditionalVariantValues, cvv.id);
			if (cond !== null && conditionals.findIndex(c => c.id === cvv.id) === -1) {
				conditionals.push({
					id: cvv.id,
					value: cond,
				});
			}
		});
		csvContent.push(...conditionals.map(c => [c.id, c.value]));


		csvContent.push(['', '']);

		if (this.isSolar) {
			csvContent.push(['location', selectSolarLocation(this.state)?.name]);
			csvContent.push(['activity', selectSolarActivityLevel(this.state)]);
			csvContent.push(['shadowLevel', selectSolarShadowLevel(this.state)]);
			csvContent.push(['azimuth', selectSolarAzimuth(this.state)]);
			csvContent.push(['azimuth angle', selectSolarAzimuthAngle(this.state)]);
			csvContent.push(['dimmProfile', selectSolarDimmProfile(this.state)]);
			csvContent.push(['', '']);
		}


		csvContent.push(['totalPriceInEuro', this.price.totalPriceInEuro]);
		csvContent.push(['totalBuildCosts', this.price.totalBuildCosts]);
		csvContent.push(['totalPriceIsNotFinal', this.price.totalPriceIsNotFinal]);

		csvContent.push(['', '']);

		if (this.price.conditionalPrices && this.price.conditionalPrices.length > 0) {
			this.price.conditionalPrices.forEach(cp => {
				csvContent.push([cp.description + ' price (' + cp.priceType + ')', cp.priceInEuro]);
				csvContent.push([cp.description + ' build price (' + cp.priceType + ')', cp.buildPriceInEuro]);
			});

			csvContent.push(['', '']);
		}

		csvContent.push(...selectVariantCodeTypes(this.state).map(
			variantCode => [variantCode.id, variantCode.code]
		));

		csvContent.push(['', '']);

		csvContent.push(['shortNumber', this.shortNumberProductModel]);

		store.dispatch(downloadCSV(
			{
				csvContent: csvContent,
			}
		));
	}

	render() {
		return html`
            ${when(this.userProfile.lightprofile_config_download, () => html`
                <section>
                    <div class="downloadSection">
                        <div>CSV Download:</div>
                        <div class="downloadBtns">
                            <button @click="${this.downloadCSV}">Download CSV</button>
                        </div>
                    </div>
                </section>
            `)}
        `;
	}
}
